export const vectorize = ({url, method = 'Auto', onSuccess, onError, ...args}) => {
    const worker = new Worker(new URL("worker.js", import.meta.url));

    worker.onmessage = (e)=> {
      console.log('vectorize.worker.onmessage', e);
      const vectorized = e.data.vectorized;
      worker.terminate();
      onSuccess && onSuccess({ ...args, url, method, vectorized });
    };

    worker.onerror = (...e) => {
      console.warn('vectorize.worker.onerror', e);
      worker.terminate();
      onError && onError(e, { ...args, url, method });
    };

    worker.postMessage({ ...args, url, method });
};